import React from 'react';
import Hero from './components/Hero';
import Story from './components/Story';
import Testimonials from './components/Testimonials';
import CTAButton from './components/CTAButton';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Top Bar */}
      <div className="bg-teal-600 h-1.5 w-full"></div>
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center border-b border-slate-100">
        <span className="text-xl font-bold text-teal-800 tracking-tight">Nancy's Wellness</span>
      </div>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8 pb-12">
        <Hero />
        
        <Story />
        
        <div className="my-10">
          <CTAButton text="See the Exact CitrusBurn I Use" />
        </div>

        <Testimonials />

        <div className="mt-12 mb-8">
          <CTAButton text="Check CitrusBurn Availability Here" className="opacity-90" />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default App;